import React from 'react';
import PropTypes from 'prop-types';

import Img from '../../Img';
import styles from './ratingInfograph.scss';

const RatingInfograph = (props) => {
	const { isMobile, closePopUp, type } = props;

	const isPickleball = type === 'pickleball';
	const pickleballRatingInfograph = isMobile ? 'pb-rating-mobile' : 'pb-rating-desktop';
	const tennisRatingInfograph = isMobile ? 'tennis-rating-mobile' : 'tennis-rating-desktop';
	const ratingInfograph = isPickleball ? pickleballRatingInfograph : tennisRatingInfograph;
	const sportType = isPickleball ? 'Pickleball' : 'Tennis';
	const learnMoreLink = isPickleball ? 'https://support.universaltennis.com/support/solutions/folders/9000198229' : 'https://support.universaltennis.com/support/solutions/folders/9000185834';

	const handleLearnMoreClick = () => {
		window.open(learnMoreLink);
	};

	return (
    <div className={styles.ratingInfograph}>
        <div className={styles.closeIconContainer}>
            <Img
                alt="close"
                src="/img/icons/close-icon-white.svg"
                className={styles.closeIcon}
                onClick={closePopUp}
            />
        </div>
        <Img
            alt={`${sportType} Rating Infograph`}
            src={`/img/${ratingInfograph}.svg`}
        />
        <div className={styles.infographLink}>
            <a href="#" onClick={handleLearnMoreClick} className="text-small" target="_blank" rel="noopener noreferrer">
					Click here to learn more about how our ratings work
            </a>
        </div>
    </div>
	);
};

RatingInfograph.propTypes = {
	isMobile: PropTypes.bool.isRequired,
	type: PropTypes.string.isRequired,
	closePopUp: PropTypes.func.isRequired,
};

export default RatingInfograph;
